import React from "react";
import Button from "@material-ui/core/Button";
import Close from "@material-ui/icons/Close";

const DeleteButton = (props) => {
  return (
    <Button
      variant="outlined"      
      onClick={props.handleOnClick}
      className="delete-btn"
    >
      <Close style={{ fontSize: 10 }} />
    </Button>
  );
};

export default DeleteButton;
